import { render } from "./InsuranceList.vue?vue&type=template&id=6db05928&scoped=true"
const script = {}

import "./InsuranceList.vue?vue&type=style&index=0&id=6db05928&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6db05928"

export default script